// extracted by mini-css-extract-plugin
module.exports = {"other":"other__2cJs_","password":"password__2x0Co","footer":"footer__1m1w3","footerText":"footerText__3gwfl","forgot":"forgot__2OrjM"};